/* tslint:disable */
/* eslint-disable */
/**
 * Role Requirements API
 * ap-southeast-2
 *
 * The version of the OpenAPI document: 1.0.dev
 * Contact: RoleReqs_DevTeam@seek.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const WorkType = {
    Contract: 'Contract',
    FullTime: 'Full-Time',
    Internship: 'Internship',
    PartTime: 'Part-Time',
    Temporary: 'Temporary'
} as const;

export type WorkType = typeof WorkType[keyof typeof WorkType];



